import GameScreenLayout from "@/components/GameScreenLayout"
import {
  GameRulesBlock,
  GUARDIANS_GAME_RULES_INTRO,
  GUARDIANS_GAME_RULES_SECTIONS,
} from "@/constants/guardiansGameRules"

function Block({ block }: { block: GameRulesBlock }) {
  if (block.type === "paragraphs") {
    return (
      <div className="space-y-2">
        {block.paragraphs.map((p) => (
          <p key={p.slice(0, 24)} className="text-sm text-guardians-muted">
            {p}
          </p>
        ))}
      </div>
    )
  }
  if (block.type === "bullets") {
    return (
      <ul className="list-disc space-y-1 pl-5 text-sm text-guardians-muted">
        {block.bullets.map((b) => (
          <li key={b.slice(0, 24)}>{b}</li>
        ))}
      </ul>
    )
  }
  if (block.type === "highlight") {
    return (
      <p className="rounded-lg border border-guardians-accent/30 bg-guardians-accent/10 px-3 py-2 text-sm">
        {block.text}
      </p>
    )
  }
  if (block.type === "note") {
    return <p className="text-xs italic text-guardians-muted">{block.text}</p>
  }
  if (block.type === "table") {
    return (
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead>
            <tr>
              {block.table.headers.map((h) => (
                <th key={h} className="border-b border-white/10 py-1 pr-2">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.table.rows.map((row) => (
              <tr key={row.join("|")}>
                {row.map((cell) => (
                  <td key={cell} className="border-b border-white/5 py-1 pr-2">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {block.caption ? (
          <p className="mt-1 text-[10px] text-guardians-muted">{block.caption}</p>
        ) : null}
      </div>
    )
  }
  return null
}

export default function RulesPage() {
  return (
    <GameScreenLayout title={GUARDIANS_GAME_RULES_INTRO.title} backTo="/play">
      <p className="mb-6 text-sm text-guardians-muted">
        {GUARDIANS_GAME_RULES_INTRO.subtitle}
      </p>
      <div className="space-y-8">
        {GUARDIANS_GAME_RULES_SECTIONS.map((section) => (
          <section key={section.number}>
            <h2 className="mb-3 text-base font-semibold text-guardians-accent">
              {section.number}. {section.title}
            </h2>
            <div className="space-y-4">
              {section.blocks.map((block, i) => (
                <Block key={`${section.number}-${i}`} block={block} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </GameScreenLayout>
  )
}
